import jwtDecode from "jwt-decode";

export const isStaging = () =>
	window.location?.host === "sso-staging.cosmogas.com";

function isExpired(expTime) {
	// Otteniamo il tempo corrente in secondi dividendolo per 1000
	const currentTime = Math.floor(Date.now() / 1000);

	// Ritorna true se il tempo corrente ha superato l'expiration time
	return currentTime > expTime;
}

export function isTokenExpired(token) {
	try {
		const { exp } = jwtDecode(token);

		if (typeof exp !== "number") {
			return true;
		}

		return isExpired(exp);
	} catch (error) {
		return true;
	}
}
